import React, { useEffect, useRef } from 'react'
import { useState } from '../hooks'
import Box from '../layout/Box'
import Svg from '../media/Svg'
import Flex from '../layout/Flex'
import { Text,Table, TableContainer, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react'

const TableDisplay = (props) => {
  const {
    table = [],
    color
  } = props  

  const scrollRef = useRef()
  const [enableScrollLeft, setEnableScrollLeft] = useState(false)
  const [enableScrollRight, setEnableScrollRight] = useState(true)

  const tableArray = table[0]
  const headerArray = tableArray?.header?.headerConfig

  const rows = tableArray?.row || []
  const headers = headerArray || []

  const handleScroll = (direction) => {
    if (scrollRef?.current) {
      const scrollAmount = 150
      scrollRef?.current?.scrollBy({
        left: direction === 'right' ? scrollAmount : -scrollAmount,
        behavior: "smooth"
      })
    }
    setTimeout(checkScroll, 300)
  }

  const checkScroll = () => {
    const el = scrollRef?.current
    if (!el) return

    const { scrollLeft, scrollWidth, clientWidth } = el

    setEnableScrollLeft(scrollLeft > 0)
    setEnableScrollRight(scrollLeft < scrollWidth - clientWidth - 1)
  }

  useEffect(() => {
    const el = scrollRef?.current
    if (!el) return

    checkScroll()

    el.addEventListener('scroll', checkScroll)

    return () => {
      el.removeEventListener('scroll', checkScroll)
    }
  }, [])

  return (
    <Flex w="100%">
      {enableScrollLeft && ( 
        <Box
          zIndex={10}
          w="40px"
          h={{ base: '40%', md: '100%'}}
          cursor="pointer"
          display="flex"
          alignItems="center"
          justifyContent="center"
          alignSelf="center"
          boxShadow="-1px -1px 8px rgb(0 0 0 / 20%)"
          onClick={() => handleScroll('left')}
          transition="all 0.3s"
          _hover={{ w: "50px", background: "linear-gradient(to right, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%)" }}
          role="group"
        >
          <Text fontSize="24px" color={{color}} _groupHover={{ fontWeight: "800", transform: "scale(1.2)" }}>{'<'}</Text>
        </Box>)}
      <TableContainer w="100%" maxH="600px" ref={scrollRef} overflowX="hidden" overflowY="scroll">
        <Table sx={{ width: "max-content" }}>
          <Thead>
            <Tr>
              {headers.map((header) => (
                <Th backgroundColor={header?.backgroundColor} key={header.key} border="1px solid #c1c1c1" borderTop="none" textAlign="center" fontSize="14px">
                  <Box dangerouslySetInnerHTML={{ __html: header?.label }}></Box>
                </Th>
              ))}
            </Tr>
          </Thead>
          <Tbody>
            {rows.map((row, rowIndex) => (
              <Tr key={row.id || rowIndex}>
                {headers.map((header) => {
                  const cell = row.cell?.find(
                    (c) => c.keyHeader === header.key
                  )
                  return (
                    <Td key={header.key} color={header?.textColorColumn} backgroundColor={cell?.backgroundColor || header?.backgroundColorColumn} border="1px solid #c1c1c1" textAlign="center" fontSize="14px" whiteSpace="pre-line" wordBreak="break-word">
                      <Flex alignItems="flex-start">
                        <Svg data={cell?.picto} width="18px" height="auto" />
                        <Box ml="8px" dangerouslySetInnerHTML={{ __html: cell?.label }}></Box>
                      </Flex>
                    </Td>
                  )
                })}
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
      {enableScrollRight && (<Box
          zIndex={10}
          w="40px"
          h={{ base: '40%', md: '100%'}}
          cursor="pointer"
          display="flex"
          alignItems="center"
          justifyContent="center"
          alignSelf="center"
          boxShadow="-1px -1px 8px rgb(0 0 0 / 20%)"
          onClick={() => handleScroll('right')}
          transition="all 0.3s"
          _hover={{ w: "50px", background: "linear-gradient(to left, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%)" }}
          role="group"
        >
          <Text fontSize="24px" color={{color}} _groupHover={{ fontWeight: "800", transform: "scale(1.2)" }}>{'>'}</Text>
        </Box>)}
    </Flex>
  )
}

export default React.memo(TableDisplay)